module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_c('div', {
    staticClass: "col-md-12 market-update-left"
  }, [_c('h4', [_vm._v("Total Rewards Transactions")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.total_rewards_spent)))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n        Rewards Transactions\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "notifications"
  }, [_c('table', {
    staticClass: "table hidden-sm hidden-xs"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "table hidden-md hidden-lg"
  }, _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewWalletTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewWalletTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('h5', [_vm._v("Transaction Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
    staticStyle: {
      "padding": "5px",
      "color": "#ffffff"
    },
    style: ({
      backgroundColor: _vm.wallet_transaction.wallet_transaction_type_color
    })
  }, [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_current_balance)))]), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_ref != '') ? _c('div', [(_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Service REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_ref))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_action_by_admin == 1) ? _c('div', [_vm._m(1), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_action_by_admin_descr))])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Current Balance(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Topup By Admin: ")]), _vm._v("Yes")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce4490fc"}!./src/components/Rewards/template.html
// module id = 172
// module chunks = 0